import { error } from 'react-notification-system-redux';
import { all, put, takeLatest } from 'redux-saga/effects';
import * as actions from './auth.actions';
import { logout, tokenRetrieved } from './auth.actions';
import { hideLoader, showLoader } from '@topconagriculture/loader';
import { AuthLoaders } from '../config';
export function* tokenRetrievedSaga(action) {
    try {
        yield put(actions.setAuthProps({
            params: {},
            result: action.payload,
        }));
        yield put(actions.loginDone());
    }
    catch (err) {
        yield put(error({
            translationKey: 'common:errors.login',
            autoDismiss: 2,
            position: 'bc',
        }));
    }
}
export function* logoutSaga() {
    yield put(showLoader(AuthLoaders.isLoggingOut));
    try {
        yield put(actions.logout.done({
            params: {},
            result: {},
        }));
    }
    catch (e) {
        yield put(error({
            translationKey: 'common:errors.logout',
            autoDismiss: 2,
            position: 'bc',
        }));
    }
    yield put(hideLoader(AuthLoaders.isLoggingOut));
}
export function* watchAuthSaga() {
    yield all([yield takeLatest(tokenRetrieved, tokenRetrievedSaga), yield takeLatest(logout.started, logoutSaga)]);
}
//# sourceMappingURL=auth.saga.js.map